import {
    BgBG,
    CsCZ,
    DaDK,
    DeDE,
    ElGR,
    EnGB,
    EsES,
    EtEE,
    FiFI,
    FrFR,
    HrHR,
    HuHU,
    ItIT, JaJP,
    LtLT,
    LvLV,
    NlNL,
    NnNO, PlPL, PtPT,
    RoRO,
    RuRU,
    SkSK,
    SlSI,
    SvSE, UkUA, ZhCN
} from "../../../../Constants/locales";

export const languages= [
    {
        value: CsCZ,
        label: "Čeština",
        selected: false,
    },
    {
        value: DaDK,
        label: "Dansk",
        selected: false,
    },
    {
        value: DeDE,
        label: "Deutsch",
        selected: false,
    },
    {
        value: EnGB,
        label: "English",
        selected: false,
    },
    {
        value: EsES,
        label: "Español",
        selected: false,
    },
    {
        value: FrFR,
        label: "Français",
        selected: false,
    },
    {
        value: ItIT,
        label: "Italiano",
        selected: false,
    },
    {
        value: NlNL,
        label: "Nederlands",
        selected: false,
    },
    {
        value: NnNO,
        label: "Norsk",
        selected: false,
    },
    {
        value: PlPL,
        label: "Polski",
        selected: false,
    },
    {
        value: PtPT,
        label: "Português",
        selected: false,
    },
    {
        value: FiFI,
        label: "Suomi",
        selected: false,
    },
    {
        value: SvSE,
        label: "Svenska",
        selected: false,
    },
    {
        value: ElGR,
        label: "Ελληνικά",
        selected: false,
    },
    {
        value: JaJP,
        label: "日本語",
        selected: false,
    },
    {
        value: ZhCN,
        label: "汉语",
        selected: false,
    },
    {
        value: BgBG,
        label: "Български",
        selected: false,
    },
    {
        value: EtEE,
        label: "Eesti",
        selected: false,
    },
    {
        value: HrHR,
        label: "Hrvatski",
        selected: false,
    },
    {
        value: HuHU,
        label: "Magyar",
        selected: false,
    },
    {
        value: LtLT,
        label: "Lietuvių",
        selected: false,
    },
    {
        value: LvLV,
        label: "Latviešu",
        selected: false,
    },
    {
        value: RoRO,
        label: "Română",
        selected: false,
    },
    {
        value: RuRU,
        label: "Русский",
        selected: false,
    },
    {
        value: SkSK,
        label: "Slovenčina",
        selected: false,
    },
    {
        value: SlSI,
        label: "Slovenščina",
        selected: false,
    },
    {
        value: UkUA,
        label: "Українська",
        selected: false,
    },
];
export default languages;
